export const ASSET_DEFAULT_PAGE = ""
export const ASSET_PAGES_BASE = {
  "": "Overview",
  alerts: "Alerts",
  forecast: "Forecasting",
  monitoring: "Monitoring",
  reporting: "Reporting",
  download: "Download",
  maintenance: "Maintenance",
  settings: "Settings",
}
export const ASSET_PAGES_WITH_STATUS = {
  history: "Log",
}

export const pages = (
  location: string,
  asset: boolean,
  servicingEnabled: boolean = true,
  assetForecastEnabled: boolean = true,
  hideReports: boolean = false
): { section: string; name: string; pages: Record<string, string>; defaultPage: string } => {
  const page = location.split("/").pop()

  let sectionPages: Record<string, string> = {}
  let defaultPage = ""
  if (asset) {
    sectionPages = servicingEnabled ? { ...ASSET_PAGES_BASE, ...ASSET_PAGES_WITH_STATUS } : { ...ASSET_PAGES_BASE }
    if (!assetForecastEnabled) {
      delete sectionPages.forecast
    }
    if (hideReports) {
      delete sectionPages.reporting
    }
    defaultPage = ASSET_DEFAULT_PAGE
  }

  let section = page ?? defaultPage
  let name = sectionPages[section]
  if (!name) {
    section = defaultPage
    name = sectionPages[defaultPage]
  }

  return { section, name, pages: sectionPages, defaultPage }
}
